import API from './apiClient';

export const trackVisit = (page) => API.post('/visitors/track', { page });
export const fetchVisitorStats = () => API.get('/visitors');
